import React from "react";
import {FormControl} from "react-bootstrap";
import * as PropTypes from "prop-types";

export function SampleEventPicker(props) {
    const {onChange, sampleEvents, value, emptyValue = null} = props;
	return <FormControl
		as="select"
		className="sample-event-picker"
		placeholder="Select Year"
		value={value}
		onChange={onChange}
	>
		{
			emptyValue && <option value="">{emptyValue}</option>
		}
		{
			sampleEvents?.map(([sampleEventId, sampleEventName, disabled]) => (
				<option value={sampleEventId}
				        key={sampleEventId}
				        disabled={disabled}
				>{sampleEventName}</option>
			))
		}
	</FormControl>;
}

SampleEventPicker.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    sampleEvents: PropTypes.array
};
